<template>
  <section class="info-section">
    <h3
      class="section-title"
      :class="{ 'section-title--empty': histories.length === 0 }"
    >
      相談サービス利用履歴{{ histories.length === 0 ? ' 無し' : '' }}
    </h3>
    <div
      v-if="histories.length > 0"
      class="history-scroll"
    >
      <table class="info-table">
        <thead>
          <tr>
            <th>日時</th>
            <th>対象の子</th>
            <th>相談種別</th>
            <th>主訴</th>
            <th />
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="history in histories"
            :key="history.key"
          >
            <td class="date-cell">{{ displayValue(history.datetime) }}</td>
            <td>
              {{ displayValue(history.childName) }}
              <template v-if="history.childId != null">
                <br>
                ID: {{ history.childId }}
              </template>
            </td>
            <td class="consultation-type-cell">
              <template v-for="(part, i) in history.consultationType.split(' / ')" :key="i">
                <span v-if="i > 0" class="type-sub">{{ part }}</span>
                <span v-else>{{ part }}</span>
              </template>
            </td>
            <td class="complaint-cell">
              {{ displayValue(history.complaint) }}
            </td>
            <td>
              <v-btn
                size="small"
                color="#33B5B4"
                prepend-icon="mdi-open-in-new"
                @click="$emit('open', history)"
              >
                閲覧
              </v-btn>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script setup>
defineProps({
  histories: {
    type: Array,
    default: () => [],
  },
});

defineEmits(["open"]);

const displayValue = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  return value;
};
</script>

<style lang="scss" scoped>
.info-section {
  background-color: #fff;
  border: 1px solid #e8e8e8;
  padding: 10px;
  margin-bottom: 10px;
}

.section-title {
  color: #33B5B4;
  font-size: clamp(16px, 1vw, 20px);
  line-height: 1.25;
  font-weight: 700;
  margin-bottom: 6px;
}

.info-table {
  width: 100%;
  border-collapse: collapse;
}

.info-table thead {
  background: #efefef;
}

.info-table th,
.info-table td {
  text-align: left;
  border-bottom: 1px solid #e4e4e4;
  padding: 6px;
  font-size: 12px;
  line-height: 1.45;
  color: #333;
  vertical-align: top;
}

.complaint-cell {
  max-width: 220px;
  white-space: normal;
  word-break: break-word;
}

.info-table td.date-cell {
  color: #999;
}

.consultation-type-cell {
  span {
    display: block;
  }
}

.history-scroll {
  max-height: 200px;
  overflow-y: auto;
}

.section-title--empty {
  color: #888;
}

@media (max-width: 1280px) {
  .section-title {
    font-size: 15px;
  }

  .info-table th,
  .info-table td {
    font-size: 11px;
  }
}
</style>
